import React from 'react';
import PropTypes from 'prop-types';

function Checkbox(props) {
  return (
    <label key={props.listId} htmlFor={props.listId}>
      <input
        type="checkbox"
        name={props.listId}
        id={props.listId}
        checked={props.checked}
        onChange={props.onChange}
        className="newsletter__checkbox"
      />
      <span className="newsletter__option">{props.choice}</span>
    </label>
  );
}

Checkbox.propTypes = {
  listId: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  choice: PropTypes.string.isRequired
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/views/components/newsletters/checkbox.js